import { useState, useEffect } from 'react';
import API from '../../services/api';
import toast from 'react-hot-toast';

var ROLE_COLORS = { student:'#2563eb', alumni:'#059669', teacher:'#7c3aed', admin:'#d97706', superadmin:'#dc2626' };
var ALL_ROLES   = ['student','alumni','teacher','admin','superadmin'];

function StatCard(props) {
  return (
    <div style={{ background:'#fff',borderRadius:16,padding:'20px 24px',border:'1px solid #e2e8f0',boxShadow:'0 1px 3px rgba(0,0,0,0.05)' }}>
      <div style={{ width:44,height:44,borderRadius:12,background:props.color+'22',display:'flex',alignItems:'center',justifyContent:'center',fontSize:22,marginBottom:12 }}>{props.emoji}</div>
      <p style={{ fontSize:28,fontWeight:800,color:'#1e293b',margin:0 }}>{props.value}</p>
      <p style={{ fontSize:13,color:'#64748b',marginTop:4 }}>{props.label}</p>
    </div>
  );
}

export default function SuperAdminDashboard() {
  var ss  = useState(null);     var stats     = ss[0];      var setStats    = ss[1];
  var us  = useState([]);       var users     = us[0];      var setUsers    = us[1];
  var ts  = useState(0);        var total     = ts[0];      var setTotal    = ts[1];
  var ps  = useState(1);        var pages     = ps[0];      var setPages    = ps[1];
  var pgs = useState(1);        var page      = pgs[0];     var setPage     = pgs[1];
  var se  = useState('');       var search    = se[0];      var setSearch   = se[1];
  var rf  = useState('');       var roleFilter= rf[0];      var setRoleFilter=rf[1];
  var ls  = useState(false);    var loading   = ls[0];      var setLoading  = ls[1];
  var na  = useState({name:'',email:'',password:''}); var newAdmin = na[0]; var setNewAdmin = na[1];
  var cs  = useState(false);    var creating  = cs[0];      var setCreating = cs[1];
  var sf  = useState(false);    var showForm  = sf[0];      var setShowForm = sf[1];
  var at  = useState('overview');var activeTab= at[0];      var setActiveTab= at[1];

  useEffect(function() {
    API.get('/admin/stats').then(function(resp) { setStats(resp.data.stats); }).catch(function(){});
  }, []);

  function fetchUsers(pg, sq, rl) {
    var p  = pg !== undefined ? pg : page;
    var s  = sq !== undefined ? sq : search;
    var r  = rl !== undefined ? rl : roleFilter;
    setLoading(true);
    var params = 'page=' + p + '&limit=15';
    if (s) params += '&search=' + encodeURIComponent(s);
    if (r) params += '&role=' + encodeURIComponent(r);
    API.get('/admin/users?' + params).then(function(resp) {
      setUsers(resp.data.users || []);
      setTotal(resp.data.total || 0);
      setPages(resp.data.pages || 1);
      setPage(p);
    }).catch(function() {
      toast.error('Failed to load users.');
    }).finally(function() {
      setLoading(false);
    });
  }

  useEffect(function() {
    if (activeTab === 'users') fetchUsers(1, search, roleFilter);
  }, [activeTab]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(function() {
    if (activeTab !== 'users') return;
    var timer = setTimeout(function() { fetchUsers(1, search, roleFilter); }, 350);
    return function() { clearTimeout(timer); };
  }, [search, roleFilter]); // eslint-disable-line react-hooks/exhaustive-deps

  function handleCreateAdmin(evt) {
    evt.preventDefault();
    if (!newAdmin.name || !newAdmin.email || !newAdmin.password) { toast.error('All fields required.'); return; }
    setCreating(true);
    API.post('/admin/create-admin', newAdmin).then(function() {
      toast.success('Admin created! ✅');
      setShowForm(false);
      setNewAdmin({name:'',email:'',password:''});
      fetchUsers(1, '', '');
    }).catch(function(err) {
      toast.error(err.message || 'Failed.');
    }).finally(function() {
      setCreating(false);
    });
  }

  function toggleActive(id) {
    API.put('/admin/users/' + id + '/toggle-active').then(function(resp) {
      toast.success(resp.data.message);
      setUsers(function(prev) {
        return prev.map(function(u) { return u._id === id ? Object.assign({},u,{isActive:!u.isActive}) : u; });
      });
    }).catch(function(err) { toast.error(err.message || 'Failed.'); });
  }

  function deleteUser(id, name) {
    if (!window.confirm('Delete ' + name + '? This cannot be undone.')) return;
    API.delete('/admin/users/' + id).then(function() {
      toast.success('User deleted.');
      setUsers(function(prev) { return prev.filter(function(u) { return u._id !== id; }); });
      setTotal(function(t) { return t - 1; });
    }).catch(function(err) { toast.error(err.message || 'Failed.'); });
  }

  function clearFilters() { setSearch(''); setRoleFilter(''); fetchUsers(1,'',''); }

  var inpStyle = { width:'100%',padding:'10px 14px',borderRadius:10,border:'1.5px solid #e2e8f0',fontSize:14,outline:'none',boxSizing:'border-box',background:'#f8fafc',color:'#1e293b' };

  var usersByRole = (stats && stats.usersByRole) ? stats.usersByRole : [];
  var maxCount    = Math.max.apply(null, usersByRole.map(function(x){ return x.count; }).concat([1]));

  return (
    <div style={{ padding:24,maxWidth:1200 }}>

      {/* Header */}
      <div style={{ display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:24,flexWrap:'wrap',gap:12 }}>
        <div>
          <h1 style={{ fontSize:24,fontWeight:800,color:'#1e293b',margin:0 }}>Super Admin — System Overview 🛡️</h1>
          <p style={{ color:'#64748b',marginTop:6,fontSize:14 }}>Full control over the Alumni Portal.</p>
        </div>
        <button onClick={function(){ setShowForm(!showForm); }}
          style={{ padding:'10px 20px',background:'#dc2626',color:'#fff',border:'none',borderRadius:12,fontWeight:700,fontSize:14,cursor:'pointer' }}>
          {showForm ? '✕ Cancel' : '+ Create Admin'}
        </button>
      </div>

      {/* Create Admin */}
      {showForm && (
        <div style={{ background:'#fff',borderRadius:16,padding:24,border:'2px solid #fca5a5',marginBottom:24 }}>
          <h3 style={{ margin:'0 0 16px',color:'#1e293b',fontSize:16,fontWeight:700 }}>🛡️ Create New Admin</h3>
          <form onSubmit={handleCreateAdmin}>
            <div style={{ display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(200px,1fr))',gap:12,marginBottom:14 }}>
              {[{key:'name',label:'Full Name',ph:'Admin Name',type:'text'},{key:'email',label:'Email',ph:'admin@college.edu',type:'email'},{key:'password',label:'Password',ph:'Min 8 chars',type:'password'}].map(function(f) {
                return (
                  <div key={f.key}>
                    <label style={{ display:'block',fontSize:12,fontWeight:600,color:'#374151',marginBottom:6 }}>{f.label}</label>
                    <input type={f.type} value={newAdmin[f.key]}
                      onChange={function(evt) { var v = evt.target.value; setNewAdmin(function(prev){ return Object.assign({},prev,{[f.key]:v}); }); }}
                      placeholder={f.ph} style={inpStyle} />
                  </div>
                );
              })}
            </div>
            <button type="submit" disabled={creating} style={{ padding:'10px 28px',background:'#dc2626',color:'#fff',border:'none',borderRadius:10,fontWeight:700,fontSize:14,cursor:'pointer' }}>
              {creating ? '⏳ Creating...' : '✅ Create Admin'}
            </button>
          </form>
        </div>
      )}

      {/* Stats */}
      <div style={{ display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(150px,1fr))',gap:16,marginBottom:28 }}>
        <StatCard emoji="👥" label="Total Users"    value={(stats && stats.totalUsers)   || 0} color="#2563eb" />
        <StatCard emoji="💼" label="Active Jobs"    value={(stats && stats.totalJobs)    || 0} color="#059669" />
        <StatCard emoji="📅" label="Total Events"   value={(stats && stats.totalEvents)  || 0} color="#7c3aed" />
        <StatCard emoji="⏳" label="Pending Alumni" value={(stats && stats.pendingAlumni)|| 0} color="#d97706" />
      </div>

      {/* Tabs */}
      <div style={{ display:'flex',gap:4,background:'#f1f5f9',borderRadius:12,padding:4,marginBottom:20,width:'fit-content' }}>
        {[{id:'overview',label:'📊 Overview'},{id:'users',label:'👥 All Users'}].map(function(tab) {
          var active = activeTab === tab.id;
          return (
            <button key={tab.id} onClick={function(){ setActiveTab(tab.id); }}
              style={{ padding:'8px 20px',borderRadius:10,border:'none',cursor:'pointer',fontWeight:active?700:500,fontSize:14,
                background:active?'#fff':'transparent',color:active?'#1e293b':'#64748b',
                boxShadow:active?'0 1px 4px rgba(0,0,0,0.1)':'none' }}>
              {tab.label}
            </button>
          );
        })}
      </div>

      {/* Overview */}
      {activeTab === 'overview' && (
        <div style={{ display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(320px,1fr))',gap:20 }}>
          <div style={{ background:'#fff',borderRadius:16,padding:20,border:'1px solid #e2e8f0' }}>
            <h2 style={{ fontSize:16,fontWeight:700,color:'#1e293b',margin:'0 0 20px' }}>📊 Users by Role</h2>
            {ALL_ROLES.map(function(role) {
              var found = usersByRole.find(function(x){ return x._id === role; });
              var count = found ? found.count : 0;
              var pct   = Math.round((count / maxCount) * 100);
              var col   = ROLE_COLORS[role] || '#64748b';
              return (
                <div key={role} style={{ marginBottom:16 }}>
                  <div style={{ display:'flex',justifyContent:'space-between',marginBottom:6 }}>
                    <span style={{ fontSize:13,fontWeight:600,color:'#374151',textTransform:'capitalize' }}>{role}</span>
                    <span style={{ fontSize:13,fontWeight:700,color:'#1e293b' }}>{count}</span>
                  </div>
                  <div style={{ height:8,background:'#f1f5f9',borderRadius:999,overflow:'hidden' }}>
                    <div style={{ height:'100%',width:pct+'%',background:col,borderRadius:999 }} />
                  </div>
                </div>
              );
            })}
          </div>

          <div style={{ background:'#fff',borderRadius:16,padding:20,border:'1px solid #e2e8f0' }}>
            <div style={{ display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:16 }}>
              <h2 style={{ fontSize:16,fontWeight:700,color:'#1e293b',margin:0 }}>🕐 Recent Registrations</h2>
              <button onClick={function(){ setActiveTab('users'); }} style={{ fontSize:12,color:'#2563eb',fontWeight:600,background:'none',border:'none',cursor:'pointer' }}>View All →</button>
            </div>
            {((stats && stats.recentUsers) || []).map(function(u) {
              var col = ROLE_COLORS[u.role] || '#64748b';
              return (
                <div key={u._id} style={{ display:'flex',alignItems:'center',gap:10,padding:'10px 0',borderBottom:'1px solid #f8fafc' }}>
                  <div style={{ width:36,height:36,borderRadius:'50%',background:col+'22',display:'flex',alignItems:'center',justifyContent:'center',fontWeight:700,color:col,fontSize:14,flexShrink:0 }}>{u.name[0]}</div>
                  <div style={{ flex:1,minWidth:0 }}>
                    <p style={{ fontWeight:600,color:'#1e293b',fontSize:13,margin:0,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap' }}>{u.name}</p>
                    <p style={{ color:'#94a3b8',fontSize:11,margin:'2px 0 0',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap' }}>{u.email}</p>
                  </div>
                  <span style={{ fontSize:10,color:col,background:col+'18',padding:'2px 8px',borderRadius:999,fontWeight:700,textTransform:'capitalize',flexShrink:0 }}>{u.role}</span>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* All Users */}
      {activeTab === 'users' && (
        <div>
          <div style={{ display:'flex',gap:10,marginBottom:16,flexWrap:'wrap' }}>
            <div style={{ position:'relative',flex:1,minWidth:200 }}>
              <span style={{ position:'absolute',left:12,top:'50%',transform:'translateY(-50%)',fontSize:14,color:'#94a3b8' }}>🔍</span>
              <input value={search} onChange={function(evt){ setSearch(evt.target.value); }}
                placeholder="Search by name or email..." style={Object.assign({},inpStyle,{paddingLeft:36})} />
            </div>
            <select value={roleFilter} onChange={function(evt){ setRoleFilter(evt.target.value); }}
              style={Object.assign({},inpStyle,{width:'auto',minWidth:150})}>
              <option value="">All Roles</option>
              {ALL_ROLES.map(function(r){ return <option key={r} value={r}>{r}</option>; })}
            </select>
            <button onClick={clearFilters}
              style={{ padding:'10px 16px',background:'#f8fafc',border:'1.5px solid #e2e8f0',borderRadius:10,fontSize:13,fontWeight:600,color:'#64748b',cursor:'pointer' }}>
              Clear
            </button>
          </div>

          <div style={{ background:'#fff',borderRadius:16,border:'1px solid #e2e8f0',overflow:'hidden' }}>
            <div style={{ padding:'14px 20px',borderBottom:'1px solid #f1f5f9',display:'flex',justifyContent:'space-between',alignItems:'center' }}>
              <span style={{ fontWeight:700,fontSize:15,color:'#1e293b' }}>All Users</span>
              <span style={{ fontSize:13,color:'#64748b' }}>{total} total</span>
            </div>

            {loading ? (
              <div style={{ padding:48,textAlign:'center',color:'#94a3b8' }}>⏳ Loading users...</div>
            ) : users.length === 0 ? (
              <div style={{ padding:48,textAlign:'center',color:'#94a3b8' }}>
                <div style={{ fontSize:40,marginBottom:8 }}>👥</div>
                <p style={{ fontWeight:600,color:'#64748b' }}>No users found</p>
              </div>
            ) : (
              <div style={{ overflowX:'auto' }}>
                <table style={{ width:'100%',borderCollapse:'collapse',fontSize:14 }}>
                  <thead>
                    <tr style={{ borderBottom:'2px solid #f1f5f9',background:'#fafafa' }}>
                      {['User','Role','Verified','Status','Joined','Actions'].map(function(h) {
                        return <th key={h} style={{ textAlign:'left',padding:'10px 14px',color:'#64748b',fontWeight:600,fontSize:11,textTransform:'uppercase',letterSpacing:0.5,whiteSpace:'nowrap' }}>{h}</th>;
                      })}
                    </tr>
                  </thead>
                  <tbody>
                    {users.map(function(u) {
                      var col = ROLE_COLORS[u.role] || '#64748b';
                      return (
                        <tr key={u._id} style={{ borderBottom:'1px solid #f8fafc' }}>
                          <td style={{ padding:'12px 14px' }}>
                            <div style={{ display:'flex',alignItems:'center',gap:8 }}>
                              <div style={{ width:34,height:34,borderRadius:'50%',background:col+'22',display:'flex',alignItems:'center',justifyContent:'center',fontWeight:700,color:col,fontSize:13,flexShrink:0 }}>{u.name[0]}</div>
                              <div>
                                <p style={{ fontWeight:600,color:'#1e293b',margin:0,fontSize:13 }}>{u.name}</p>
                                <p style={{ color:'#94a3b8',fontSize:11,margin:0 }}>{u.email}</p>
                              </div>
                            </div>
                          </td>
                          <td style={{ padding:'12px 14px' }}>
                            <span style={{ background:col+'18',color:col,fontSize:11,fontWeight:700,padding:'3px 10px',borderRadius:999,textTransform:'capitalize' }}>{u.role}</span>
                          </td>
                          <td style={{ padding:'12px 14px',fontSize:15 }}>{u.isEmailVerified ? '✅' : '❌'}</td>
                          <td style={{ padding:'12px 14px' }}>
                            <span style={{ background:u.isActive?'#dcfce7':'#fee2e2',color:u.isActive?'#16a34a':'#dc2626',fontSize:11,fontWeight:700,padding:'3px 10px',borderRadius:999 }}>
                              {u.isActive ? 'Active' : 'Inactive'}
                            </span>
                          </td>
                          <td style={{ padding:'12px 14px',color:'#64748b',fontSize:12,whiteSpace:'nowrap' }}>{new Date(u.createdAt).toLocaleDateString('en-IN')}</td>
                          <td style={{ padding:'12px 14px' }}>
                            <div style={{ display:'flex',gap:6 }}>
                              <button onClick={function(){ toggleActive(u._id); }}
                                style={{ padding:'5px 12px',background:u.isActive?'#fef3c7':'#dcfce7',color:u.isActive?'#d97706':'#16a34a',border:'none',borderRadius:6,fontSize:12,fontWeight:700,cursor:'pointer',whiteSpace:'nowrap' }}>
                                {u.isActive ? 'Deactivate' : 'Activate'}
                              </button>
                              {u.role !== 'superadmin' && (
                                <button onClick={function(){ deleteUser(u._id, u.name); }}
                                  style={{ padding:'5px 12px',background:'#fee2e2',color:'#dc2626',border:'none',borderRadius:6,fontSize:12,fontWeight:700,cursor:'pointer' }}>
                                  Delete
                                </button>
                              )}
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}

            {pages > 1 && (
              <div style={{ padding:'14px 20px',borderTop:'1px solid #f1f5f9',display:'flex',justifyContent:'center',alignItems:'center',gap:6,flexWrap:'wrap' }}>
                <button onClick={function(){ fetchUsers(Math.max(1,page-1)); }} disabled={page===1}
                  style={{ padding:'8px 14px',borderRadius:8,border:'1.5px solid #e2e8f0',background:'#fff',color:page===1?'#cbd5e1':'#374151',fontWeight:600,fontSize:13,cursor:page===1?'not-allowed':'pointer' }}>← Prev</button>
                {Array.from({length:pages}).map(function(_,i) {
                  var p = i+1;
                  return (
                    <button key={p} onClick={function(){ fetchUsers(p); }}
                      style={{ width:36,height:36,borderRadius:8,border:'1.5px solid',fontWeight:700,fontSize:13,cursor:'pointer',
                        borderColor:p===page?'#dc2626':'#e2e8f0',
                        background:p===page?'#dc2626':'#fff',
                        color:p===page?'#fff':'#374151' }}>
                      {p}
                    </button>
                  );
                })}
                <button onClick={function(){ fetchUsers(Math.min(pages,page+1)); }} disabled={page===pages}
                  style={{ padding:'8px 14px',borderRadius:8,border:'1.5px solid #e2e8f0',background:'#fff',color:page===pages?'#cbd5e1':'#374151',fontWeight:600,fontSize:13,cursor:page===pages?'not-allowed':'pointer' }}>Next →</button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
